import { useNavigation } from '@react-navigation/native';
import { useEffect, useRef, useState } from 'react';

interface UseAutoNavigationProps {
  canNavigateToResults: boolean;
  waitingScreenShownAt: number | null;
  minWaitMs?: number;
  sessionId: string;
  roomId: string;
  isHost?: boolean;
  playerName: string;
  familyId?: string;
  familyName?: string;
  friendsGroupId?: string;
  friendsGroupName?: string;
}

export function useAutoNavigation({
  canNavigateToResults,
  waitingScreenShownAt,
  minWaitMs = 1000,
  sessionId,
  roomId,
  isHost = false,
  playerName,
  familyId,
  familyName,
  friendsGroupId,
  friendsGroupName,
}: UseAutoNavigationProps) {
  const navigation = useNavigation<any>();
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const hasReplacedRef = useRef(false);

  useEffect(() => {
    if (canNavigateToResults && waitingScreenShownAt !== null) {
      const elapsed = Date.now() - waitingScreenShownAt;
      if (elapsed >= minWaitMs) {
        setShouldNavigate(true);
      } else {
        const timeout = setTimeout(() => {
          setShouldNavigate(true);
        }, minWaitMs - elapsed);
        return () => clearTimeout(timeout);
      }
    }
  }, [canNavigateToResults, waitingScreenShownAt, minWaitMs]);

  useEffect(() => {
    if (shouldNavigate) {
      if (hasReplacedRef.current) {
        return;
      }

      hasReplacedRef.current = true;
      console.log('[useAutoNavigation] Triggering navigation to MultiplayerResults', {
        sessionId,
        roomId,
        isHost,
        playerName,
      });
      try {
        navigation.replace('MultiplayerResults', {
          sessionId,
          roomId,
          isHost,
          playerName,
          familyId,
          familyName,
          friendsGroupId,
          friendsGroupName,
        });
      } catch (error) {
        if (__DEV__) console.error("[useAutoNavigation] Failed to navigate to MultiplayerResults:", error);
      }
      setShouldNavigate(false);
    }
  }, [shouldNavigate, navigation, sessionId, roomId, isHost, playerName, familyId, familyName, friendsGroupId, friendsGroupName]);
}
